/**
 * @author        justin.jeong@zumper.com (Justin Jeong)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   User Thunks
 */

import { ButterAction } from '@zcode-ui/web-zumper-global-state'
import { logger } from '../../../../logger'
import * as Api from '../../../../shared/api'

export const updateUser = (params) => async (dispatch) => {
  try {
    await Api.user.update(params)
  } catch (e) {
    // NOTE: _never_ send the full error to rollbar when dealing with user information
    try {
      logger.error(new Error(`Failed to update user: Status ${e.data.status} ${e.data.reason}`))
    } catch (_) {
      logger.error(new Error('Failed to update user'))
    }
    dispatch(
      ButterAction.addErrorButterBar({
        message: 'Something went wrong. Please double-check your information.',
      })
    )
  }
}
